import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TyTestimonialsComponent } from './components/ty-testimonials/ty-testimonials.component';
import { NgxGlideModule } from 'ngx-glide';

@NgModule({
  declarations: [TyTestimonialsComponent],
  imports: [
    CommonModule,
    NgxGlideModule
  ],
  exports: [TyTestimonialsComponent]
})
export class TyTestimonialsModule { }
